import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/ebit-calculator',
  component: () => import('../../routes/EbitCalculator.svelte'),
  card: {
    id: 'ebit-calculator',
    title: 'EBIT Calculator',
    description:
      'Calculate EBIT (Earnings Before Interest & Taxes) and EBIT margin from revenue, COGS, and operating expenses.',
    icon: 'analytics',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/ebit-calculator',
    category: 'Business',
  },
  seo: {
    title: 'EBIT Calculator – Earnings Before Interest & Taxes Calculator',
    description:
      'Free EBIT calculator to measure operating profitability. Enter revenue, COGS, and operating expenses to calculate EBIT and EBIT margin. Compare operating efficiency with our free online calculator.',
  },
};

export default meta;
